import { render, staticRenderFns } from "./BPASS.vue?vue&type=template&id=7718e91a"
import script from "./BPASS.vue?vue&type=script&lang=js"
export * from "./BPASS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports